import { Switch, Route } from "react-router-dom";
import ShareRoot from "./ShareRoot";
import DownloadRoot from "./DownloadRoot";
import DraftRoute from "./drafts/DraftRoute";
import HomeRouter from "./home/HomeRouter";
import ManageRouter from "./home/ManageRouter";
import SettingsPage from "./settings/SettingsRouter";
import LeftMenu from "./LeftMenu";
import Header from "./Header";
import Dock from "./Dock";
import PreviewRoute from "../main/PreviewRoute";
import Upload from "./upload/Upload";
import { useState } from "react";

const MainRoute = (props) => {
  let { params } = props.match;
  const [lang, setLang] = useState("en");

  return (
    <>
      <div className="home_container relafull">
        <LeftMenu params={params} />
        <div className="main_content">
          <Header lang={lang} setLang={setLang} />
          <div className="main_content_container">
            <Dock p={params} />
            <Switch>
              <Route path="/home" component={HomeRouter} />
              <Route path="/manage/:filter" component={ManageRouter} />
              <Route path="/settings" component={SettingsPage} />
              <Route path="/drafts/:popfilter/:tmpTrigger/:id" component={DraftRoute} />
            </Switch>
          </div>
        </div>
      </div>
      <Upload params={params} />
      <PreviewRoute params={params} />
      <ShareRoot params={params} />
      <DownloadRoot params={params} />
    </>
  );
};

export default MainRoute;
